'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _styles = require('../settings/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  root: {
    marginBottom: '16px',
    marginLeft: '16px',
    marginTop: '0',
    marginRight: '16px',
    position: 'relative',
    height: '48px',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    backgroundColor: _colors2.default.white,
    boxShadow: _styles2.default.depthShadows[0],
    overflow: 'auto'
  },
  input: {
    flex: '1',
    height: '100%',
    appearance: 'none',
    color: _colors2.default.primaryText,
    fontSize: '16px',
    lineHeight: '16px',
    fontWeight: 'inherit',
    fontFamily: 'inherit',
    outline: 'none',
    padding: '0 8px',
    border: 0,
    backgroundColor: 'inherit',
    margin: 0,

    ':focus': {
      outline: 'none'
    },

    ':disabled': {
      opacity: '0.5'
    }
  },
  disabled: {
    opacity: '0.5'
  },
  buttons: {
    display: 'flex'
  },
  placeholder: {
    color: _colors2.default.placeholderText
  },
  textarea: {
    height: '100%',
    resize: 'none',
    overflow: 'auto',
    padding: '15px 8px 16px',
    boxSizing: 'border-box'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message-input/styles.js
// module id = 317
// module chunks = 0